<lms-breadcrumb [label]="'actions.createItinerary'"></lms-breadcrumb>
<lms-itinerary-editor (onSave)="onSave($event)">
  <gl-button
    color-secondary
    text="{{ 'actions.cancel' | translate }}"
    (onClick)="goBack()"
    form-actions-before
  ></gl-button>
</lms-itinerary-editor>
